module.exports = __webpack_public_path__ + "img/cart-shopping-solid.ef9ac4f6.svg";